<div class="padding-bottom-16" *ngFor="let section of metrics">
	<div [class.metric-disabled]="sectionsToDisable.includes(section.componentSectionDependency)">
		<img ada-decorative class="padding-right-5" [remote-src]="'client-proposal/' + section.icon + '.svg'" onerror="this.style.display = 'none'" />
		<span class="text-bold" [innerHTML]="section.name"></span>
		<span class="section-name-separator text-bold" dcrHTMLKey="PROPOSAL_METRIC_SECTION_NAME_SEPARATOR">:</span>
		<span [innerHTML]="section.overview"></span>
	</div>
</div>
